import { render, staticRenderFns } from "./createtopic.vue?vue&type=template&id=9a769f2e&scoped=true&"
import script from "./createtopic.vue?vue&type=script&lang=ts&"
export * from "./createtopic.vue?vue&type=script&lang=ts&"
import style0 from "./createtopic.vue?vue&type=style&index=0&id=9a769f2e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a769f2e",
  null
  
)

export default component.exports